var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[_c('Topbar'),_c('HorizontalNavbar',{attrs:{"type":_vm.topbar,"width":_vm.layoutWidth,"menu":_vm.menuPosition}}),_c('div',{staticClass:"content-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)])]),_c('Rightbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }